import type { z } from 'zod';

import { institutionDetailsReportingSchema } from '@/services/api/profile';

export const institutionFuturesReportingSchema = institutionDetailsReportingSchema;

export type InstitutionFuturesReporting = z.infer<typeof institutionFuturesReportingSchema>;

export type InstitutionFuturesReportingOrDefaults = InstitutionFuturesReporting | Partial<InstitutionFuturesReporting>;
